"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ui = exports.Box = void 0;
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var styled_1 = __importDefault(require("@emotion/styled"));
var Text_1 = require("../Text");
var theme_1 = require("../theme");
var styled_system_1 = require("styled-system");
var ErrorMessage = function (_a) {
    var showError = _a.showError, message = _a.message;
    return (showError && (react_1.default.createElement(ErrorRow, null,
        react_1.default.createElement(react_feather_1.AlertCircle, { stroke: theme_1.theme.colors.red700, width: 12, height: 12, style: { marginTop: "2px", minWidth: "12px" } }),
        react_1.default.createElement(Text_1.Text, { variant: "paragraphSmall", color: "red700", ml: 0 }, message))));
};
var ErrorRow = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  align-items: flex-start;\n  margin-top: ", ";\n"])), theme_1.theme.space.xsmall);
var Label = function (_a) {
    var label = _a.label, description = _a.description, sideDescription = _a.sideDescription;
    return (react_1.default.createElement("div", null,
        label && (react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "space-between",
                marginBottom: description
                    ? theme_1.theme.space.xxsmall
                    : theme_1.theme.space.xsmall,
            } },
            react_1.default.createElement(Text_1.Text, { variant: "uiSmall500" }, label),
            react_1.default.createElement(Text_1.Text, { variant: "uiTiny500", color: "gray600" }, sideDescription))),
        description && (react_1.default.createElement(Text_1.Text, { variant: "paragraphMedium", color: "gray600", mb: 1 }, description))));
};
exports.Box = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), styled_system_1.space, styled_system_1.layout, styled_system_1.background, styled_system_1.border, styled_system_1.color, styled_system_1.flexbox, styled_system_1.grid);
var Wrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), styled_system_1.space, styled_system_1.layout);
var baseStyles = {
    background: theme_1.theme.colors.white,
    border: "1px solid ".concat(theme_1.theme.colors.gray400),
    color: theme_1.theme.colors.gray900,
    borderRadius: "8px",
    outline: "none",
    padding: "7px 11px",
    transition: "all 100ms",
    "::placeholder": {
        color: theme_1.theme.colors.gray500,
    },
    boxSizing: "border-box", // TODO: Why wont this type correctly?
};
var errorStyles = {
    boxShadow: "0px 0px 0px 3px ".concat(theme_1.theme.colors.red000),
    borderColor: theme_1.theme.colors.red700,
};
var focusedStyles = {
    boxShadow: "0px 0px 0px 3px ".concat(theme_1.theme.colors.blue300),
    borderColor: theme_1.theme.colors.blue600,
};
var _selectStyles = function (error) {
    return {
        menuPortal: function (provided, state) { return (__assign(__assign({}, provided), { zIndex: 100 })); },
        menu: function (provided, state) { return (__assign(__assign({}, provided), { marginTop: 6, marginBottom: 6 })); },
        menuList: function (provided, state) { return (__assign(__assign({}, provided), { paddingTop: 0, paddingBottom: 0, borderRadius: 4 })); },
        option: function (provided, state) { return (__assign(__assign({}, provided), { backgroundColor: state.isFocused || state.isSelected
                ? theme_1.theme.colors.gray200
                : provided.backgroundColor, color: theme_1.theme.colors.gray900, fontSize: 16, "&:active": {
                backgroundColor: theme_1.theme.colors.blue100,
            } })); },
        control: function (provided, state) { return (__assign(__assign({}, provided), { borderRadius: "8px", boxShadow: error
                ? "0 0 0 3px ".concat(theme_1.theme.colors.red000)
                : state.isFocused
                    ? "0 0 0 3px ".concat(theme_1.theme.colors.blue300)
                    : "0 0 0 3px transparent", borderColor: error
                ? theme_1.theme.colors.red700
                : state.isFocused
                    ? theme_1.theme.colors.blue600
                    : theme_1.theme.colors.gray400, minHeight: 40, "&:hover": {
                boxShadow: error
                    ? "0 0 0 3px ".concat(theme_1.theme.colors.red000)
                    : state.isFocused
                        ? "0 0 0 3px ".concat(theme_1.theme.colors.blue300)
                        : "0 0 0 3px transparent",
                borderColor: error
                    ? theme_1.theme.colors.red700
                    : state.isFocused
                        ? theme_1.theme.colors.blue600
                        : theme_1.theme.colors.gray400,
            } })); },
        multiValue: function (provided, state) { return (__assign(__assign({}, provided), { display: "flex", backgroundColor: theme_1.theme.colors.gray200, gap: "4px", borderRadius: "15px", padding: "4px 8px", ":hover": {
                backgroundColor: theme_1.theme.colors.gold100,
                color: theme_1.theme.colors.gold800,
            } })); },
        multiValueLabel: function (provided, state) { return (__assign(__assign(__assign({}, provided), Text_1.textStyles.uiTiny500), { padding: "0", paddingLeft: "0", color: "inherit" })); },
        multiValueRemove: function (provided, state) { return (__assign(__assign({}, provided), { padding: "0", ":hover": {
                backgroundColor: "inherit",
                color: theme_1.theme.colors.gray900,
                cursor: "pointer",
            } })); },
        placeholder: function (provided, state) { return (__assign(__assign({}, provided), { paddingTop: "4px", marginTop: "auto", marginBottom: "auto" })); },
    };
};
exports.ui = {
    ErrorMessage: ErrorMessage,
    Label: Label,
    Wrapper: Wrapper,
    _selectStyles: _selectStyles,
    baseStyles: baseStyles,
    errorStyles: errorStyles,
    focusedStyles: focusedStyles,
};
var templateObject_1, templateObject_2, templateObject_3;
